import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AppShell from './AppShell';
import { getThemeConfig, setThemeConfig, PRESET_THEMES, type ThemeConfig } from '../utils/theme';
import './ThemeEdit.css';

const ThemeEdit: React.FC = () => {
  const navigate = useNavigate();
  const [selectedTheme, setSelectedTheme] = useState<ThemeConfig>(getThemeConfig());

  useEffect(() => {
    // 页面加载时应用当前主题
    const currentTheme = getThemeConfig();
    setSelectedTheme(currentTheme);
  }, []);

  const handleThemeClick = (theme: ThemeConfig) => {
    setSelectedTheme(theme);
    setThemeConfig(theme);
  };

  const header = (
    <div className="theme-edit-header app-shell-header-content">
      <button
        onClick={() => navigate('/profile/settings')}
        className="back-button"
        title="返回设置"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
      </button>
      <h1>主题颜色</h1>
    </div>
  );

  return (
    <AppShell header={header} footer={null}>
      <div className="theme-edit-container">
        <div className="theme-edit-content">
          <div className="theme-edit-section">
            <div className="theme-preset-grid">
              {PRESET_THEMES.map((theme) => {
                const isSelected = selectedTheme.name === theme.name;
                return (
                  <button
                    key={theme.name}
                    type="button"
                    className={`theme-preset-card ${isSelected ? 'active' : ''}`}
                    onClick={() => handleThemeClick(theme)}
                  >
                    <div 
                      className="theme-preset-color" 
                      style={{ 
                        backgroundColor: theme.background,
                        color: theme.primaryText
                      }}
                    >
                      {theme.name}
                    </div>
                    {isSelected && (
                      <div className="theme-preset-check">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                      </div>
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </AppShell>
  );
};

export default ThemeEdit;

